<button
  nbxButton
  type="button"
  variant="utility"
  [icon]="icon()"
  [badge]="badge() ?? null"
  [class]="styleClass()"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel() || tooltip() ? (ariaLabel() || tooltip() | transloco) : null"
  (click)="menu.toggle($event)"
></button>
<p-menu
  [model]="primeMenuItems()"
  [popup]="true"
  [appendTo]="appendTo()"
  #menu
>
  <ng-template
    #item
    let-item
  >
    <div
      class="flex items-center gap-2 cursor-pointer transition-colors px-2 py-2"
      [class.bg-neutral-50]="selectedItem()?.value === item.id"
      [class.font-medium]="selectedItem()?.value === item.id"
    >
      @if (item.icon) {
        <i [class]="item.icon"></i>
      }
      <span class="text-sm">{{ item.label }}</span>
    </div>
  </ng-template>
</p-menu>
